import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { WIZARD_STEPS } from "./wizardSteps";

export default function WizardStepper({
  currentStep,
  isStepReachable,
  onSelectStep,
}: {
  currentStep: number;
  isStepReachable: (step: number) => boolean;
  onSelectStep: (step: number) => void;
}) {
  return (
    <ol className="flex flex-wrap items-center gap-x-2 gap-y-2">
      {WIZARD_STEPS.map((wizardStep) => {
        const isCurrent = wizardStep.step === currentStep;
        const isDone = wizardStep.step < currentStep;
        const isReachable = isStepReachable(wizardStep.step);
        return (
          <li key={wizardStep.step} className="flex items-center gap-2">
            <button
              type="button"
              disabled={!isReachable}
              onClick={() => onSelectStep(wizardStep.step)}
              className={cn(
                "flex items-center gap-2 rounded-md px-2 py-1 text-sm transition-colors",
                isReachable ? "hover:bg-muted" : "cursor-not-allowed opacity-50",
                isCurrent ? "text-foreground font-semibold" : "text-muted-foreground",
              )}
            >
              <span
                className={cn(
                  "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold",
                  isCurrent && "bg-primary text-primary-foreground",
                  !isCurrent && isDone && "bg-primary/10 text-primary",
                  !isCurrent && !isDone && "bg-muted text-muted-foreground",
                )}
              >
                {isDone ? <Check className="h-3.5 w-3.5" /> : wizardStep.step}
              </span>
              {wizardStep.title}
            </button>
            {wizardStep.step < WIZARD_STEPS.length && (
              <span className="h-px w-4 bg-border" aria-hidden="true" />
            )}
          </li>
        );
      })}
    </ol>
  );
}
